module.exports = __webpack_public_path__ + "img/item-bg.2172f941.png";